import { Stack, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { asyncRequest } from "src/services/network";
import TiejunPicker from "src/components/common/TiejunPicker";

const BindTeijunParentDialog = ({ tiejun, open, onReload, onClose }) => {
  const [parent, setParent] = useState({});

  const [form, setForm] = useState({
    remark: ''
  });

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    const { msg } = await asyncRequest({
      path: "/user/tiejun/bindParent",
      data: {
        ...form,
        id: tiejun.id,
        pid: parent.id,
      },
    });

    setForm({
      nickname: "",
    });
    alert(msg, "success");
    onReload();
  }

  function handleSelectTiejun() {
    TiejunPicker({
      onSelect(val) {
        setParent(val);
      },
    });
  }

  return (
    <FormDialog title="绑定辅导员" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="用户" required>
        <Stack direction="row" alignItems="center" spacing={2}>
          <UserInfo {...tiejun.user} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="辅导员" required>
        <Stack direction="row" alignItems="center" spacing={2} onClick={handleSelectTiejun}>
          <UserInfo {...(parent.user || {})} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="备注" required>
        <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
      </FormItem>
    </FormDialog>
  );
};

export default BindTeijunParentDialog;
